/* eslint-disable camelcase */
import { getTeamLabelByNumber } from '../../utils/utils'
import { addZero } from '@/utils/filters'

let shootoutStartingSideFlag = false
let isFirstThrow = true
let isFirstMatchFormatEvent = true

export default {
  // 'this' - $store
  byActionType: {
    numberOfPlayersChangeEvents ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    }
  },
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { isShootoutSeriesFormat } = this
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        has_timer,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      if (isShootoutSeriesFormat) return

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set,
        withoutPeriodsUpdating: !isFirstMatchFormatEvent
      })

      isFirstMatchFormatEvent = false

      this.setIngameProperty({
        property: 'hasTimer',
        value: has_timer
      })

      if (overtimeFormat.name === 'Penalty series' || overtimeFormat.name === 'Серия пенальти') {
        this.setIngameProperty({
          property: 'shootoutStatisticTitle',
          value: 'trader.penalty.shootout.score'
        })
        this.setIngameProperty({
          property: 'shootoutPeriodName',
          value: 'P'
        })
      } else {
        this.setIngameProperty({
          property: 'shootoutStatisticTitle',
          value: 'trader.penalty.shootout.score.bullets'
        })
        this.setIngameProperty({
          property: 'shootoutPeriodName',
          value: 'SO'
        })
      }

      if (!is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    'RED_CARD' (event) {
      const { getIngameData } = this
      this.setIngameProperty({
        property: 'untilGameEndPenaltyCount',
        value: getIngameData.untilGameEndPenaltyCount + 1
      })
    },
    'INNER_SYNC_EVENT' ({ GamePeriod, ScoreHome, ScoreAway, extra: { team1, team2, is_shootout } }) {
      const { getMatchPeriods } = this
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      shootoutStartingSideFlag = true

      this.setPeriod({ GamePeriod: GamePeriod, ScoreHome, ScoreAway })
      this.setPenaltyShootouts({ GamePeriod })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'leftSideTeam',
        value: TeamNumber
      })
    },
    'START_SHOOTOUT' (event) {
      this.setPenaltyShootouts(event)
    },
    'START_PERIOD' ({ GamePeriod, extra: { team1, team2 } }) {
      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      if ((team1 || team1 === 0) && (team2 || team2 === 0)) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'START_OVERTIME_PERIOD' ({ extra: { team1, team2 } }) {
      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      if ((team1 || team1 === 0) && (team2 || team2 === 0)) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'THROW' (event) {
      if (isFirstThrow) {
        this.setPenaltyShootouts(event)
      }
      isFirstThrow = false
    },
    'TIMEOUT' () {
      this.setDelayedEventsTimerStopped(true)
    },
    'TIMEOUT_FINISH' () {
      this.setDelayedEventsTimerStopped(false)
    },
    'PENALTY_FINISH' (event) {
      this.editPeriodScore(event)
    },
    'FINISH_OVERTIME_PERIOD' (event) {
      const { getMatchPeriods } = this
      const { extra: { is_shootout, team1, team2 }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      if ((team1 || team1 === 0) && (team2 || team2 === 0)) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPeriod({ GamePeriod: event.GamePeriod + 1, ScoreHome: event.ScoreHome, ScoreAway: event.ScoreAway })
      this.setPenaltyShootouts({ GamePeriod: event.GamePeriod + 1 })
    },
    'FINISH_PERIOD' (event) {
      this.setTimer(event)
      const { getMatchPeriods } = this
      const { extra: { is_shootout }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPenaltyShootouts(event)
    },
    'START_PENALTY_SERIES' (event) {
      this.setPenaltyShootouts(event)
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods, getIngameData } = this
      const relatedEvent = getEventCache[RelatedEventNumber]

      if (!relatedEvent) return

      const { EventCode, TeamNumber, extra: { team1, team2 } } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (EventCode === 'UNTIL_GAME_ENDS_PENALTY') {
        const { untilGameEndPenaltyCount } = getIngameData

        if (!untilGameEndPenaltyCount) return

        this.setIngameProperty({
          property: 'untilGameEndPenaltyCount',
          value: untilGameEndPenaltyCount - 1
        })
      }

      if (EventCode === 'START_SHOOTOUT') {
        shootoutStartingSideFlag = true

        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod)
        this.setStatisticPeriod(getCurrentPeriod)
      }

      if (EventCode === 'START_OVERTIME_PERIOD') {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
      if (EventCode === 'FINISH_OVERTIME_PERIOD') {
        shootoutStartingSideFlag = false
      }

      if (EventCode === 'GOAL') {
        this.setScore(event)
      }

      this.setCanceled(event)
      this.refreshDelayedEvents(event)
    },
    'ADDITIONAL_TIME' ({ extra: { minutes, period } }) {
      const { getIngameData: { additionalTimeInPeriod } } = this
      const result = JSON.parse(JSON.stringify(additionalTimeInPeriod))
      result[period] = additionalTimeInPeriod[period] + minutes
      this.setIngameProperty({
        property: 'additionalTimeInPeriod',
        value: result
      })
    },
    'UNTIL_GAME_ENDS_PENALTY' () {
      const { getIngameData: { untilGameEndPenaltyCount } } = this

      this.setIngameProperty({
        property: 'untilGameEndPenaltyCount',
        value: untilGameEndPenaltyCount + 1
      })
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'START_SHOOTOUT' () {
      return this.$t('trader.shootout.start.bullets')
    },
    'START_PERIOD' () {
      if (this.getFormats.matchFormat.name === '4х15') {
        return this.$t('event.startQuarter')
      }

      return this.$t('event.startOfHalf')
    },
    'FINISH_PERIOD' () {
      if (this.getFormats.matchFormat.name === '4х15') {
        return this.$t('event.endQuarter')
      }

      return this.$t('event.endOfHalf')
    },
    'ADJUST_POINTS' () {
      return this.$t('hockey.adjust.points')
    },
    'FACE_OFF' (event) {
      if (!event.eventInfo) return ''

      const { extra: { point } } = event

      return `${event.eventInfo.title} / ${this.$t('hockey.face.off.point')}: ${point}`
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle, getWinner } = this
      const { type, overriddenType, overriddenName } = getMatchPeriods[GamePeriod]
      const teamTitle = getWinner === 'home' ? homeTeamTitle : awayTeamTitle

      if (getWinner === 'draft') {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      if (overriddenType === 'shootout' && overriddenName === 'SO') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.bullets')}`
      }

      if (overriddenType === 'shootout' && overriddenName === 'P') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.penaltyshootout')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  eventPlaytimeFunction (event) {
    const { Playtime, GamePeriod } = event

    if (!Playtime || !GamePeriod) return '00:00'

    const { getFormats } = this.getters
    const {
      matchFormat: {
        count: mainCount,
        duration: mainDuration
      },
      overtimeFormat: {
        duration: overtimeDuration
      }
    } = getFormats
    const isOvertime = GamePeriod > mainCount
    const secondsCount = Playtime / 1000
    const minutes = Math.floor(secondsCount / 60)
    const seconds = Math.floor(secondsCount % 60)
    let needToTransform = false

    if (!isOvertime) {
      const compareValue = GamePeriod * mainDuration

      needToTransform = compareValue < minutes || (compareValue === minutes && seconds > 0)
    } else {
      const compareValue = mainCount * mainDuration + (GamePeriod - mainCount) * overtimeDuration

      needToTransform = compareValue < minutes || (compareValue === minutes && seconds > 0)
    }

    if (!needToTransform) return `${addZero(minutes)}:${addZero(seconds)}`

    if (!isOvertime) {
      const maintimeMinutes = mainDuration * GamePeriod

      return `${maintimeMinutes}:00 (${minutes - maintimeMinutes}:${addZero(seconds)})`
    }

    const overtimrMinutes = mainDuration * mainCount + overtimeDuration * (GamePeriod - mainCount)

    return `${overtimrMinutes}:00 (${minutes - overtimrMinutes}:${addZero(seconds)})`
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType, overriddenName } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout' && overriddenName === 'SO') return this.$t('trader.win.bullets')
    if (overriddenType === 'shootout' && overriddenName === 'P') return this.$t('trader.win.penaltyshootout')

    if (type === 'overtime') return this.$t('trader.win.overtime')

    return this.$t('trader.win.maintime')
  }
}
